import React from 'react';
import { Container } from 'react-bootstrap';
import Header from '../../Components/Header';
import Footer from '../../Components/Footer';
import Contactimg from '../../Components/ContactUs/Contactimg';

function ContactUs() {
    
  return (
    <div>
      <Container fluid style={{ margin: 0, padding: 0 }} >
        <div>
          <Header title="contact" />
        </div>

        <div>
          <Contactimg/>
        </div>
        

     <div>
      <Footer/>
     </div>

      </Container>
    </div>
    
  );
}

export default ContactUs